import React from 'react';
import styled from 'styled-components';
import { TextField as MuiTextField } from '@material-ui/core';

const S = {
  TextField: styled(({ InputProps, ...otherProps }) => (
    <MuiTextField
      InputProps={{
        classes: {
          root: 'input-root',
          input: 'input',
          notchedOutline: 'notchedOutline',
          focused: 'focused',
        },
        ...InputProps,
      }}
      {...otherProps}
    />
  ))`
    .input {
      height: 40px;
      padding: 0 0.875rem;
      font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    }
    .notchedOutline {
      border: 1px solid ${({ theme }) => theme.palette.grey[400]};
    }
    .focused .notchedOutline {
      border-width: 2px;
    }
  `,
};

const TextField = props => (
  <S.TextField
    variant="outlined"
    {...props}
  />
);

export default TextField;
